import type { PlantingLifecycleStatus } from '../../models/Planting';

export const PLANTING_STATUS_META: Record<PlantingLifecycleStatus, { label: string; color: string }> = {
  planned: { label: 'Планируется', color: 'purple' },
  active: { label: 'Активна', color: 'green' },
  holding: { label: 'На складе', color: 'cyan' },
  transferred: { label: 'Перемещена', color: 'geekblue' },
  sold: { label: 'Продана', color: 'gold' },
  dead: { label: 'Погибла', color: 'volcano' },
  archived: { label: 'Архив', color: 'default' },
};

export const plantingStatusOptions = (Object.keys(PLANTING_STATUS_META) as PlantingLifecycleStatus[]).map((status) => ({
  value: status,
  label: PLANTING_STATUS_META[status].label,
}));

export const formatPlantingStatus = (status?: PlantingLifecycleStatus | null) => {
  if (!status) return 'Не указан';
  return PLANTING_STATUS_META[status]?.label ?? status;
};
